import { FormStore } from '@roc/feature-app-core';

const form = {
  fields: {
    secondAppraisal: {
      value: '',
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
  //Flag
  isSecondAppraisalRequired: { value: false },
};

export class SecondAppraisalFormStore extends FormStore {
  constructor(globalStore) {
    super(form, globalStore);
  }
}
